export const PaymentPaymentableIDFormKey = 'Paymentable ID';
export const PaymentPaymentableTypeFormKey = 'Paymentable Type';
export enum PaymentPaymentableType {
    BookingEvent = 'bookingevent',
    Client = 'client',
    BookableResource = 'bookableresource',
    FormSubmission = 'formsubmission',
    PackageGrant = 'packagegrant',
    EventType = 'eventtype',
}
export const KeysRelativeToDates = [
    'Start Date & Time',
    'End Date & Time',
    'Start Time',
    'End Time',
    'Start Date',
    'End Date',
    'Submitted At',
    'Payment Date & Time',
    'Expiration Date',
    'Created',
    'Expiration',
    'Client Added Date',
    'Event Start Time',
    'Next Renewal Date',
].map(key => key.toLowerCase());

export const KeysRelativeToMoney = [
    'Price',
    'Payment Amount',
    'Amount Paid',
    'Amount Paid for Event',
    'Invoice Total',
].map(key => key.toLowerCase());

export const KeySuffixesRelativeToMoney = [
    ' revenue',
];

export const KeysStrictlyFilteredAsFreeText = [
    'Form Name', // this is required for FormSelect to operate
].map(key => key.toLowerCase());

export const KeysThatWillBeHidden = [
    'Client Id',
    'Admin Emails',
    'Type Id',
    'Start Time',
    'End Time',
    'Start Date',
    'End Date',
    'id',
    'event-type-id',
    PaymentPaymentableIDFormKey,
].map(key => key.toLowerCase());

export const EventTypeColumnName = 'Event Type';
export const RevenuePerTypeGroupColumnName = 'Amount Paid';
export const RevenuePerTypeColumnsToSum = [
    RevenuePerTypeGroupColumnName,
    'Price',
];

export const RevenuePerTypeColumnSuffixesToSum = [
    ' Revenue',
];

export const EVENT_KEY_PRIORITAZATION = [
    'Event Type',
    RevenuePerTypeGroupColumnName,
    'Start Date & Time',
    'End Date & Time',
    'Client First Name',
    'Client Last Name',
    'Canceled',
];
export const CLIENT_KEY_PRIORITAZATION = [
    'Client First Name',
    'Client Last Name',
    'Client Email',
    'Client Phone',
    'Client ID',
];
export const FORM_KEY_PRIORITAZATION = [
    'Form Name',
    'Submitted At',
    'Client Full Name',
    'Client Email',
];
export const PACKAGE_GRANT_KEY_PRIORITAZATION = [
    'Package Name',
    'Package Type',
    'Package Expiration',
    'Amount Remaining',
    'Client First Name',
    'Client Last Name',
    'Client Email',
    'Client Phone',
    'Client ID',
];

export const FilterDateFormatToUse = 'yyyy LLL dd';
export const DisplayDateFormatToUse = 'MMMM d, yyyy h:mma ZZZZ'; // December 10, 2024 6:00pm EST
export const SortDateFormatToUse = 'EEE, MMM d, yyyy h:mma';

export const FORM_KEY_TO_BE_USED_FOR_CLICK_EVENT = 'id';
export const FORM_KEYS_THAT_CAN_BE_CLICKED = [
    FORM_KEY_TO_BE_USED_FOR_CLICK_EVENT,
];
